import React from 'react';

import CountWords from '@/src/components/CountWords/CountWords';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import ModalHoc from 'src/constrains/ModalHOC';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

import { useDispatch, useSelector } from 'react-redux';
import { ActionType } from 'src/types/common/common';

import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getSocialMediaList,
  getSocialMediaMenu,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onSocialMediaOptionChange,
  onSocialMediaTitleChange,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/slice';

import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';

import { Input } from '@/src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';

import { generateNewSocialMediaOption } from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/common';

import SocialMediaEdit from './MediaEditor';

import { useI18n } from 'src/hooks/useRouterChange';
import {
  errKey,
  validateSocialMedia,
} from 'src/pages/SalesChannelContentEditor/SalesChannelFooter/tools';
import { store } from 'src/store';
import {
  generalValuePickerAccordingLanguage,
  getI18nFromGeneral,
  i18nGet,
} from 'src/tools/tools';

const SocialMedia = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data, modalOp, specificError, isPrimary } = props;
  const titleErr = specificError[errKey.socialMediaSelectorTitle];
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;

  const { title, socialMediaList } = data || {};
  const d = useDispatch();
  // const _params: any = useParams();
  // const { contentUuid } = _params;
  const mediaList = useSelector(getSocialMediaList());
  //console.log('mediaList', mediaList);

  const handleOnChildGenerate = (data, index) => {
    const { mediaType } = data;
    return (
      <TextAndEditIcon
        name={mediaType}
        onClick={() => {
          setShowModal(true);
          setModalTitle(getI18n('salesChannelContent.index.editSocialMedia'));
          setModalContent(
            <SocialMediaEdit
              isPrimary={isPrimary}
              data={data}
              mediaList={mediaList}
              onCancel={onModalCancel}
              onConfirm={(data) => {
                const type = ActionType.modify;
                d(
                  onSocialMediaOptionChange({
                    type,
                    target: data,
                    index,
                  }),
                );
              }}
            />,
          );
        }}
      />
    );
  };

  const handleOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    const type = ActionType.reorder;
    d(
      onSocialMediaOptionChange({
        type,
        from: oldIndex,
        to: newIndex,
      }),
    );
  };

  const handleOnAdd = () => {
    const data = generateNewSocialMediaOption();
    setShowModal(true);
    setModalTitle(getI18n('salesChannelContent.index.addSocialMedia'));
    setModalContent(
      <SocialMediaEdit
        isPrimary={isPrimary}
        data={data}
        mediaList={mediaList}
        onCancel={onModalCancel}
        onConfirm={(data) => {
          const type = ActionType.add;
          d(
            onSocialMediaOptionChange({
              type,
              target: data,
            }),
          );
        }}
      />,
    );
  };

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper
          size='small'
          title={`${getI18n('salesChannelContent.index.socialMediaTitle')}*`}
          rightPart={
            <CountWords count={(title || '').length} allCount={100} />
          }>
          <Input
            error={(titleErr || []).length > 0}
            help={(titleErr || []).join(' ')}
            maxLength={100}
            size='large'
            value={title}
            onChange={(title) => {
              d(onSocialMediaTitleChange(title));
            }}
          />
        </ItemWrapper>
      </Section>
      <DragNDropColumns
        disabled={!isPrimary}
        hideAdd={!isPrimary}
        hideTitle
        childGenerate={handleOnChildGenerate}
        data={socialMediaList}
        droppableId={'salesChannelContentFooterSocialMedia'}
        onSort={handleOnSort}
        // hideAdd={hideAdd}
        onAdd={handleOnAdd}
        addText={`+ ${getI18n('salesChannelContent.index.addSocialMedia')}`}
        {...(isPrimary
          ? {
              onDelete: (index) => {
                const type = ActionType.delete;
                d(
                  onSocialMediaOptionChange({
                    index,
                    type,
                  }),
                );
              },
            }
          : {})}
      />
    </React.Fragment>
  );
};

export default ErrorProcessingHOC(
  ModalHoc(SocialMedia, {
    width: 600,
  }),
  {
    getCollapseOpenStatus,
    onCollapseOpen,
    id: EnumCollapseId.socialMedia,
    getContent: getSocialMediaMenu,
    title: getI18nFromGeneral('general.hOCTitle.socialMedia'),
    getErrorDisplay: getCollapseValidationMsgDisplay,
    onErrorChange,
    expandOffset: 0,
    getSubmitStamp,
    validation: (x, validationProps) => {
      const { isPrimary } = validationProps || {};

      return validateSocialMedia(x, isPrimary);
    },
    headerProps: {
      dotsFunction: [
        {
          onClick: () => {
            const text = generalValuePickerAccordingLanguage({
              cn: '社交媒体',
              hk: '社交媒體',
              gb: 'Social Media',
            });

            store.dispatch(onSocialMediaTitleChange(text));
          },
          key: 'Reset',
          body: getI18nFromGeneral('general.hOCTitle.reset'),
          isDangerous: true,
        },
      ],
      hasDots: true,
      hideDotsWhenNotPrimary: true,
    },
  },
);
